import React from 'react'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
`

function WrappedLoadingState() {
  return (
    <Container className="app-theme-inverse">
      <LoadingIndicator inline ballSize={24} childrenBelow>
        <VerticalSpacer gap={8}>
          <Heading variant="heading5">Loading a year of travel...</Heading>
          <BodyText variant="small" colour="neutral-two">
            Preparing travel highlights
          </BodyText>
        </VerticalSpacer>
      </LoadingIndicator>
    </Container>
  )
}

export default WrappedLoadingState
